import { render, staticRenderFns } from "./gc-batch-goods-in.vue?vue&type=template&id=2f021a68"
import script from "./gc-batch-goods-in.vue?vue&type=script&lang=js"
export * from "./gc-batch-goods-in.vue?vue&type=script&lang=js"
import style0 from "./gc-batch-goods-in.vue?vue&type=style&index=0&id=2f021a68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports